import { getCurrentUser } from './Auth';

export const userHasFeature = (featureSlug, user = null) => {
  const currentUser = user || getCurrentUser();

  return currentUser &&
    currentUser.features &&
    currentUser.features.findIndex(f => (f.slug === featureSlug)) >= 0;
};

export const hasFeature = (features, featureSlug) => (
  !featureSlug || features.findIndex(f => (f.slug === featureSlug)) >= 0
);
